/**
 * Error codes handled by arangojs.
 *
 * See also [ArangoDB error documentation](https://www.arangodb.com/docs/stable/appendix-error-codes.html).
 *
 * @packageDocumentation
 * @internal
 */

export const TRANSACTION_NOT_FOUND = 10;
export const ERROR_ARANGO_MAINTENANCE_MODE = 503;
export const ERROR_ARANGO_CONFLICT = 1200;
export const ANALYZER_NOT_FOUND = 1202;
export const DOCUMENT_NOT_FOUND = 1202;
export const COLLECTION_NOT_FOUND = 1203;
export const VIEW_NOT_FOUND = 1203;
export const DATABASE_NOT_FOUND = 1228;
export const GRAPH_NOT_FOUND = 1924;
